<div class="container-fluid fullsize">
	<!--
		Abgelaufene Anmeldung: seit 06.09.2026 der Balken der Bibliothek statt
		eines eigenen. Er sieht selbst nach — ist der Schlüssel abgelaufen,
		versucht er die stille Erneuerung und stellt sich auf, wenn sie
		scheitert. Das rote Dreieck am Menü-Knopf gibt es dafür nicht mehr.
	-->
	<wd-sitzungs-hinweis></wd-sitzungs-hinweis>
	@if (serverBlock.blocked()) {
		<div class="ip-block-banner" role="alert">
			<i class="bi bi-exclamation-octagon-fill"></i>
			<span class="ip-block-text">{{ serverBlock.message() }}</span>
			@if (serverBlock.hasDiagnostics()) {
				<button type="button" class="btn btn-sm btn-light ip-block-diag"
					(click)="serverBlock.downloadDiagnostics()">Diagnose speichern</button>
			}
			<button type="button" class="btn-close ip-block-close" aria-label="Ausblenden"
				(click)="serverBlock.dismiss()"></button>
		</div>
	} @else if (serverBlock.probingRisk()) {
		<div class="probing-risk-banner" role="alert">
			<i class="bi bi-exclamation-triangle-fill"></i>
			<span class="ip-block-text">{{ serverBlock.probingMessage() }}</span>
			<button type="button" class="btn-close ip-block-close" aria-label="Ausblenden"
				(click)="serverBlock.dismiss()"></button>
		</div>
	}
	<!--
		Hinweis auf Datensaetze, die von zwei Seiten geaendert wurden. Steht hier und
		nicht nur im Sync-Fenster: Dort verschwand er mit dem Fenster, und wer ihn
		wegklickte, fand ihn nicht wieder. Blendet sich aus, wenn nichts offen ist.

		UEBER der Leiste, nicht darunter: Alle Voll-Hoehen-Ansichten rechnen mit
		`calc(var(--vh) - var(--navbar-height) ...)`, und --navbar-height ist die
		Unterkante der Leiste. Gemessen wird die Leiste samt allem, was VOR ihr
		steht. Unterhalb eingebaut zaehlte der Balken nicht mit, jede Ansicht waere
		um seine Hoehe zu hoch und der untere Rand rutschte aus dem Bild - ohne
		sichtbare Scrollleiste (siehe styles.css) merkt das niemand.

		Mit Knopf zum Klaeren: Seit dem 29.08.2026 laesst sich hier Feld fuer Feld
		entscheiden, welcher Wert gilt (Zeilenlisten wie die Horizontfolge im
		Ganzen). Zusaetzlich ausblendbar, damit der Balken nicht stehen bleibt,
		wenn jemand gerade nicht klaeren will; er kommt wieder, sobald eine
		weitere Fassung dazukommt.
	-->
	<wd-konflikt-hinweis [klaerbar]="true" [ausblendbar]="true"
		(klaeren)="klaereZweiFassungen()"></wd-konflikt-hinweis>
	<bp-navbar></bp-navbar>
	<div class="main-frame">
		<router-outlet></router-outlet>
	</div>
</div>
